import classnames from 'classnames'
import * as React from 'react'

import { Button, Delayed, DialogTrigger, Icon, Spinner, useDialogState } from '../../components'
import { publishModalAsyncModule } from '../../modals/publish/async-modules'
import ChartLayout from '../../models/chart_layout'
import { useAsyncModule } from '../../utils/async-modules-utils'

interface PublishProps {
  model: ChartLayout
  theme?: string
  size?: string
  rounding?: string
}

export function Publish({ model, ...props }: React.PropsWithChildren<PublishProps>) {
  const dialog = useDialogState()
  const [publishModalModule, { isLoading }] = useAsyncModule({
    ...publishModalAsyncModule,
    shouldLoadModule: dialog.visible,
    errorSeverity: 'medium',
    onError: () => dialog.hide(),
  })
  const PublishDialog = publishModalModule?.default
  const buttonProps = isLoading
    ? {
        leftContent: (
          <Delayed
            delayComponent={
              <Icon name="share" className={classnames({ 'text-white': props.theme === 'headerItem' })} />
            }
          >
            <Spinner width={16} />
          </Delayed>
        ),
      }
    : {
        as: DialogTrigger,
        state: dialog,
        leftContent: 'share',
      }
  return (
    <>
      <Button
        {...buttonProps}
        {...props}
        contentClass="hidden lg:flex"
        active={dialog.visible}
        appearance={props.children ? undefined : 'square'}
        title={props.children ? undefined : 'Share chart'}
      />
      {PublishDialog && <PublishDialog state={dialog} layoutModel={model} />}
    </>
  )
}
